<template>
  <div class="detailRecord-box">
    <el-dialog :visible.sync="dialogVisible" width="1200px" :before-close="handleClose" :close-on-click-modal="false">
      <!-- 操作栏 -->
      <div class="action-bar">
        <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker>
          <div class="income"> 
             收益总额：
            <span>{{totalIncome || 0}}</span>
          </div>
      </div>
      <!-- 表格数据 -->
      <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <el-table-column prop="uid" label="用户UID" align="center" width="120">
          <template slot-scope="scope">
            <span>{{scope.row.uid || '未知'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="performance" label="绩效" align="center" width="120">
          <template slot-scope="scope">
            <span>{{(scope.row.performance/100 || '0') | numFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="agentLevel" label="代理等级" align="center" width="120">
          <template slot-scope="scope">
            <span>{{scope.row.agentLevel || '未知'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="money" label="收益金额(推广金额)" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{(scope.row.money/100 || '0') | numFormat}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rechargeID" label="充值订单号" align="center" :show-overflow-tooltip="true" width="200">
          <template slot-scope="scope">
            <span>{{scope.row.rechargeID || '未知'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="originUID" label="被邀请用户id" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.originUID || '未知'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" align="center" :show-overflow-tooltip="true" width="200">
          <template slot-scope="scope">
            <span>{{scope.row.createdAt | changeDate}}</span>
          </template>
        </el-table-column>
      </el-table>
      <!--分页组件-->
      <div class="page-box" style="width:100%;height:70px">
        <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="form.pageNumber" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total"  v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'
import { changeTime } from '@/utils/global'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      data: '',
      time: '',
      // 收益总额
      totalIncome: '',
      form: {
        pageNumber: 1,
        pageSize: 10,
        startTime: '',
        endTime: '',
      }
    }
  },
   created (){this.getPopupList()},
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.form.pageSize = size
      this.form.pageNumber = 1
      this.getPopupList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.form.pageNumber = pageNumber
      this.getPopupList()
    },
    // 请求弹窗列表参数
    getPopupList(type) {
      if( type === 'status') {
        this.form.pageNumber = 1
      }
      this.loading = true;
        let form = Object.assign(this.form, { uid: this.data })
          API.getProxyDetails(form).then(res => {
        if (res.code === 200 && res.data.data) {
            this.totalIncome = res.data.totalIncome / 100
          this.tableData = res.data.data
          this.total = res.data.total
        } else {
          this.tableData = []
        }
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.loading = false
      })
    },
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.form.startTime = changeTime(time[0]) || ''
        this.form.endTime = changeTime(time[1]) || ''
      } else {
        this.form.startTime = ''
        this.form.endTime = ''
      }
      this.getPopupList('status')
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true
      this.data = data
      // 请求弹窗列表
      this.getPopupList()
    },
  }
}
</script>
<style lang="scss" scoped>
.page-box {
    margin-top: 35px;
    position: relative;
    height: 40px;
  }
  
  .action-bar{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .income {
      margin-left: 15px;
    }
  }
</style>
